/** Utilitários compartilhados entre correções auditadas (realizado, orçado, etc.). */

export const AUDITORIA_CANAIS_SOLICITACAO = [
  { id: "email", label: "E-mail" },
  { id: "reuniao", label: "Reunião" },
  { id: "whatsapp", label: "WhatsApp" },
  { id: "telefone", label: "Telefone" },
  { id: "planilha", label: "Planilha / anexo" },
  { id: "ui", label: "Pedido direto na UI" },
  { id: "outro", label: "Outro" },
] as const;

export type AuditoriaCanalSolicitacao = (typeof AUDITORIA_CANAIS_SOLICITACAO)[number]["id"];

export type AuditoriaEvento = "INSERT" | "UPDATE" | "DELETE";

export interface AuditoriaRowBase {
  id: number;
  evento: AuditoriaEvento;
  registro_id: string | null;
  ocorrido_em: string;
  origem: string | null;
  motivo: string | null;
  alterado_por: string | null;
  solicitado_por: string | null;
  canal: string | null;
  referencia_solicitacao: string | null;
  observacoes: string | null;
  solicitado_em: string | null;
  linha_resumo: string | null;
  registro_antes: Record<string, unknown> | null;
  registro_depois: Record<string, unknown> | null;
  campos_alterados: Record<string, { antes?: unknown; depois?: unknown }> | null;
}

export interface CorrigirResult {
  success: boolean;
  error?: string;
  id?: string;
}

export function labelCanalSolicitacao(canal: string | null | undefined): string {
  if (!canal) return "—";
  return AUDITORIA_CANAIS_SOLICITACAO.find((c) => c.id === canal)?.label ?? canal;
}

export function formatAuditValue(value: unknown): string {
  if (value === null || value === undefined) return "—";
  if (typeof value === "number") {
    return new Intl.NumberFormat("pt-BR", { style: "currency", currency: "BRL" }).format(value);
  }
  const s = String(value);
  if (/^\d{4}-\d{2}-\d{2}/.test(s)) {
    const d = s.slice(0, 10).split("-");
    if (d.length === 3) return `${d[2]}/${d[1]}/${d[0]}`;
  }
  return s;
}

export function eventoBadgeVariant(evento: AuditoriaEvento): "default" | "secondary" | "destructive" {
  if (evento === "INSERT") return "default";
  if (evento === "UPDATE") return "secondary";
  return "destructive";
}
